var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientcontact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.426,
    height: 20.426,
    viewBox: "0 0 20.426 20.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-872532",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930",
    transform: "translate(7.564 7.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32540",
    "data-name": "Path 32540",
    d: "M17.319,15.413a2.6,2.6,0,0,0,.511-1.532,2.681,2.681,0,1,0-5.362,0,2.6,2.6,0,0,0,.511,1.532A2.758,2.758,0,0,0,11,18.094V18.6a.64.64,0,0,0,.638.638H18.66A.64.64,0,0,0,19.3,18.6v-.511A2.758,2.758,0,0,0,17.319,15.413Zm-2.17-2.936a1.4,1.4,0,1,1-1.4,1.4A1.417,1.417,0,0,1,15.149,12.477Zm-2.872,5.489a1.533,1.533,0,0,1,1.532-1.4h2.681a1.533,1.533,0,0,1,1.532,1.4Z",
    transform: "translate(-11 -11.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931",
    transform: "translate(9.798 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32541",
    "data-name": "Path 32541",
    d: "M16.415,5.33A1.881,1.881,0,0,1,14.5,3.415a1.915,1.915,0,0,1,3.83,0A1.881,1.881,0,0,1,16.415,5.33Zm0-2.553a.6.6,0,0,0-.638.638.638.638,0,1,0,1.277,0A.6.6,0,0,0,16.415,2.777Z",
    transform: "translate(-14.5 -1.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932",
    transform: "translate(9.798 18.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32542",
    "data-name": "Path 32542",
    d: "M16.415,31.33a1.915,1.915,0,1,1,1.915-1.915A1.881,1.881,0,0,1,16.415,31.33Zm0-2.553a.638.638,0,1,0,.638.638A.6.6,0,0,0,16.415,28.777Z",
    transform: "translate(-14.5 -27.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933",
    transform: "translate(15.67 3.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32543",
    "data-name": "Path 32543",
    d: "M25.615,9.157a1.738,1.738,0,0,1-1.34-.574,1.837,1.837,0,0,1-.574-1.34,1.738,1.738,0,0,1,.574-1.34,1.969,1.969,0,0,1,2.681,0,1.837,1.837,0,0,1,.574,1.34,1.738,1.738,0,0,1-.574,1.34A1.837,1.837,0,0,1,25.615,9.157Zm0-2.553a.654.654,0,0,0-.638.638.579.579,0,0,0,.191.447.617.617,0,0,0,.894,0,.617.617,0,0,0,0-.894A.579.579,0,0,0,25.615,6.6Z",
    transform: "translate(-23.7 -5.375)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934",
    transform: "translate(3.926 15.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32544",
    "data-name": "Path 32544",
    d: "M7.215,27.557a1.738,1.738,0,0,1-1.34-.574,1.837,1.837,0,0,1-.574-1.34,1.738,1.738,0,0,1,.574-1.34,1.969,1.969,0,0,1,2.681,0,1.837,1.837,0,0,1,.574,1.34,1.738,1.738,0,0,1-.574,1.34A1.738,1.738,0,0,1,7.215,27.557Zm0-2.553a.632.632,0,0,0-.447,1.085.617.617,0,0,0,.894,0A.638.638,0,0,0,7.215,25Z",
    transform: "translate(-5.3 -23.775)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935",
    transform: "translate(18.096 9.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32545",
    "data-name": "Path 32545",
    d: "M29.415,18.33a1.915,1.915,0,1,1,1.915-1.915A1.881,1.881,0,0,1,29.415,18.33Zm0-2.553a.638.638,0,1,0,.638.638A.6.6,0,0,0,29.415,15.777Z",
    transform: "translate(-27.5 -14.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936",
    transform: "translate(1.5 9.798)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32546",
    "data-name": "Path 32546",
    d: "M3.415,18.33a1.915,1.915,0,0,1,0-3.83,1.915,1.915,0,1,1,0,3.83Zm0-2.553a.638.638,0,0,0,0,1.277.638.638,0,1,0,0-1.277Z",
    transform: "translate(-1.5 -14.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937",
    transform: "translate(15.67 15.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32547",
    "data-name": "Path 32547",
    d: "M25.615,27.557a1.738,1.738,0,0,1-1.34-.574,1.837,1.837,0,0,1-.574-1.34,1.738,1.738,0,0,1,.574-1.34,1.969,1.969,0,0,1,2.681,0,1.837,1.837,0,0,1,.574,1.34,1.738,1.738,0,0,1-.574,1.34A1.837,1.837,0,0,1,25.615,27.557Zm0-2.553a.632.632,0,0,0-.447,1.085.617.617,0,0,0,.894,0A.638.638,0,0,0,25.615,25Z",
    transform: "translate(-23.7 -23.775)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3938",
    "data-name": "Group 3938",
    transform: "translate(3.926 3.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32548",
    "data-name": "Path 32548",
    d: "M7.215,9.157a1.738,1.738,0,0,1-1.34-.574A1.738,1.738,0,0,1,5.3,7.242,1.738,1.738,0,0,1,5.874,5.9a1.969,1.969,0,0,1,2.681,0,1.837,1.837,0,0,1,.574,1.34,1.738,1.738,0,0,1-.574,1.34A1.738,1.738,0,0,1,7.215,9.157Zm0-2.553a.654.654,0,0,0-.638.638.579.579,0,0,0,.191.447.617.617,0,0,0,.894,0,.617.617,0,0,0,0-.894A.579.579,0,0,0,7.215,6.6Z",
    transform: "translate(-5.3 -5.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientcontact);
export default __webpack_public_path__ + "static/media/clientcontact.7b55f4fc45e6fe82b67555f6f0e41acd.svg";
export { ForwardRef as ReactComponent };